import React from 'react';
import { Box, Typography, Button, Fab, useTheme, useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface CalendarToolbarProps {
  onAddEvent: () => void;
}

export const CalendarToolbar: React.FC<CalendarToolbarProps> = ({ onAddEvent }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold' }}>
          Calendar
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddEvent}
          sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
        >
          Add Event
        </Button>
      </Box>

      {isMobile && (
        <Fab
          variant="extended"
          color="primary"
          onClick={onAddEvent}
          sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1200, boxShadow: 4 }}
        >
          <AddIcon sx={{ mr: 1 }} />
          Event
        </Fab>
      )}
    </>
  );
};

export default CalendarToolbar;
